// This file is auto-generated

import { Message, BinaryWriter, BinaryReader } from "google-protobuf";

import * as dep_1 from "./../google/protobuf/empty";
import * as dep_2 from "./../tolemac/pub/filter";
import * as dep_3 from "./contact";
import * as dep_4 from "./user";
import * as dep_5 from "./contact_package";
import * as dep_6 from "./package_file";

export interface IComment {
    id?: number;
    source?: CommentSource;
    contactedBy?: CommentContactedBy;
    shared?: boolean;
    content?: string;
    createdAt?: number;
    updatedAt?: number;
    /**
     * @lazy
     */
    user?: dep_4.IUser;
    /**
     * @lazy
     */
    contact?: dep_3.IContact;
    /**
     * @lazy
     */
    contactTrainingModule?: dep_5.IContactTrainingModule;
    /**
     * @lazy
     */
    packageFile?: dep_6.IPackageFile;

}
export class Comment implements IComment {

    id?: number;
    source?: CommentSource;
    contactedBy?: CommentContactedBy;
    shared?: boolean;
    content?: string;
    createdAt?: number;
    updatedAt?: number;
    user?: dep_4.User;
    contact?: dep_3.Contact;
    contactTrainingModule?: dep_5.ContactTrainingModule;
    packageFile?: dep_6.PackageFile;

    constructor(data?: Partial<IComment>) {
        if (data)
            Object.keys(data).forEach(d => this[d] = data[d])
    }
}
export class MComment extends Message implements Comment {

    constructor(data?: Partial<IComment>) {
        super();
        Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], []);
        if (!Array.isArray(data) && typeof data == "object") {
            if ("id" in data && data.id != undefined) this.id = data.id;
            if ("source" in data && data.source != undefined) this.source = data.source;
            if ("contactedBy" in data && data.contactedBy != undefined) this.contactedBy = data.contactedBy;
            if ("shared" in data && data.shared != undefined) this.shared = data.shared;
            if ("content" in data && data.content != undefined) this.content = data.content;
            if ("createdAt" in data && data.createdAt != undefined) this.createdAt = data.createdAt;
            if ("updatedAt" in data && data.updatedAt != undefined) this.updatedAt = data.updatedAt;
            if ("user" in data && data.user != undefined) this.user = new dep_4.MUser(data.user);
            if ("contact" in data && data.contact != undefined) this.contact = new dep_3.MContact(data.contact);
            if ("contactTrainingModule" in data && data.contactTrainingModule != undefined) this.contactTrainingModule = new dep_5.MContactTrainingModule(data.contactTrainingModule);
            if ("packageFile" in data && data.packageFile != undefined) this.packageFile = new dep_6.MPackageFile(data.packageFile);
        }
    }

    get id(): number {
        return Message.getField(this, 1) as number;
    }
    set id(value: number) {
        Message.setField(this, 1, value);
    }

    get source(): CommentSource {
        return Message.getField(this, 2) as CommentSource;
    }
    set source(value: CommentSource) {
        Message.setField(this, 2, value);
    }

    get contactedBy(): CommentContactedBy {
        return Message.getField(this, 3) as CommentContactedBy;
    }
    set contactedBy(value: CommentContactedBy) {
        Message.setField(this, 3, value);
    }

    get shared(): boolean {
        return Message.getField(this, 4) as boolean;
    }
    set shared(value: boolean) {
        Message.setField(this, 4, value);
    }

    get content(): string {
        return Message.getField(this, 5) as string;
    }
    set content(value: string) {
        Message.setField(this, 5, value);
    }

    get createdAt(): number {
        return Message.getField(this, 6) as number;
    }
    set createdAt(value: number) {
        Message.setField(this, 6, value);
    }

    get updatedAt(): number {
        return Message.getField(this, 7) as number;
    }
    set updatedAt(value: number) {
        Message.setField(this, 7, value);
    }

    get user(): dep_4.MUser {
        return Message.getWrapperField(this, dep_4.MUser, 8);
    }
    set user(value: dep_4.MUser) {
        Message.setWrapperField(this, 8, value);
    }

    get contact(): dep_3.MContact {
        return Message.getWrapperField(this, dep_3.MContact, 9);
    }
    set contact(value: dep_3.MContact) {
        Message.setWrapperField(this, 9, value);
    }

    get contactTrainingModule(): dep_5.MContactTrainingModule {
        return Message.getWrapperField(this, dep_5.MContactTrainingModule, 10);
    }
    set contactTrainingModule(value: dep_5.MContactTrainingModule) {
        Message.setWrapperField(this, 10, value);
    }

    get packageFile(): dep_6.MPackageFile {
        return Message.getWrapperField(this, dep_6.MPackageFile, 11);
    }
    set packageFile(value: dep_6.MPackageFile) {
        Message.setWrapperField(this, 11, value);
    }

    toObject(includeInstance: boolean = true) {
        const data = includeInstance ? new Comment() : {} as Comment;
        if (this.id != undefined) data.id = this.id;
        if (this.source != undefined) data.source = this.source;
        if (this.contactedBy != undefined) data.contactedBy = this.contactedBy;
        if (this.shared != undefined) data.shared = this.shared;
        if (this.content != undefined) data.content = this.content;
        if (this.createdAt != undefined) data.createdAt = this.createdAt;
        if (this.updatedAt != undefined) data.updatedAt = this.updatedAt;
        if (this.user != undefined) data.user = this.user.toObject(includeInstance);
        if (this.contact != undefined) data.contact = this.contact.toObject(includeInstance);
        if (this.contactTrainingModule != undefined) data.contactTrainingModule = this.contactTrainingModule.toObject(includeInstance);
        if (this.packageFile != undefined) data.packageFile = this.packageFile.toObject(includeInstance);
        return data;
    }

    serialize(): Uint8Array
    serialize(w: BinaryWriter): undefined
    serialize(w?: BinaryWriter): Uint8Array | undefined {
        const writer = w || new BinaryWriter();
        try {
                if (this.id !== undefined) writer.writeInt32(1, this.id);
                if (this.source !== undefined) writer.writeEnum(2, this.source);
                if (this.contactedBy !== undefined) writer.writeEnum(3, this.contactedBy);
                if (this.shared !== undefined) writer.writeBool(4, this.shared);
                if (this.content !== undefined) writer.writeString(5, this.content);
                if (this.createdAt !== undefined) writer.writeInt64(6, this.createdAt);
                if (this.updatedAt !== undefined) writer.writeInt64(7, this.updatedAt);
                if (this.user !== undefined) writer.writeMessage(8, this.user, () => this.user.serialize(writer));
                if (this.contact !== undefined) writer.writeMessage(9, this.contact, () => this.contact.serialize(writer));
                if (this.contactTrainingModule !== undefined) writer.writeMessage(10, this.contactTrainingModule, () => this.contactTrainingModule.serialize(writer));
                if (this.packageFile !== undefined) writer.writeMessage(11, this.packageFile, () => this.packageFile.serialize(writer));
        
        } catch (e: any) {
            if (!w) console.error(e)
            throw e
        }
        if (!w) return writer.getResultBuffer();
    }

    serializeBinary(): Uint8Array {
        return this.serialize();
    }

    static serializeBinary(data?: IComment): Uint8Array {
        return (data instanceof Message ? (data as MComment) : new MComment(data)).serializeBinary()
    }


    static deserialize(bytes: Uint8Array | BinaryReader): MComment {
        const reader = bytes instanceof Uint8Array ? new BinaryReader(bytes) : bytes;
        const message = new MComment();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
            case 1:
                    message.id = reader.readInt32();
                    break;
            case 2:
                    message.source = reader.readEnum();
                    break;
            case 3:
                    message.contactedBy = reader.readEnum();
                    break;
            case 4:
                    message.shared = reader.readBool();
                    break;
            case 5:
                    message.content = reader.readString();
                    break;
            case 6:
                    message.createdAt = reader.readInt64();
                    break;
            case 7:
                    message.updatedAt = reader.readInt64();
                    break;
            case 8:
                    reader.readMessage(message.user, () => message.user = dep_4.MUser.deserialize(reader));
                    break;
            case 9:
                    reader.readMessage(message.contact, () => message.contact = dep_3.MContact.deserialize(reader));
                    break;
            case 10:
                    reader.readMessage(message.contactTrainingModule, () => message.contactTrainingModule = dep_5.MContactTrainingModule.deserialize(reader));
                    break;
            case 11:
                    reader.readMessage(message.packageFile, () => message.packageFile = dep_6.MPackageFile.deserialize(reader));
                    break;
            
                default: reader.skipField();
            }
        }
        return message;
    }

    static override deserializeBinary(bytes: Uint8Array): MComment {
        return MComment.deserializeBinaryFromReader(new MComment(), new BinaryReader(bytes));
    }

    static override deserializeBinaryFromReader(msg: MComment, reader: BinaryReader) {
        return Object.assign(msg, MComment.deserialize(reader))
    };

}
export enum CommentContactedBy {
    UNDEFINED_CommentCatgory = 0,
    EMAIL = 1,
    INTERNE = 2,
    MAIL = 3,
    MODULE_END = 4,
    PHONE = 5,
    MARKETING = 6,
    REVIEW = 7,
}
export enum CommentSource {
    UNDEFINED_CommentSource = 0,
    GLOBAL = 1,
    PACKAGE_HISTORY = 2,
    PACKAGE_ADMINISTRATIVE = 3,
    PACKAGE_ATTENDANCES = 4,
    PACKAGE_TRACKING = 5,
}
export interface IComments {
    values?: IComment[];
    count?: number;

}
export class Comments implements IComments {

    values: Comment[];
    count?: number;

    constructor(data?: Partial<IComments>) {
        if (data)
            Object.keys(data).forEach(d => this[d] = data[d])
    }
}
export class MComments extends Message implements Comments {

    constructor(data?: Partial<IComments>) {
        super();
        Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [1], []);
        if (!Array.isArray(data) && typeof data == "object") {
            if ("values" in data && data.values != undefined) this.values = data.values.map(d => new MComment(d));
            if ("count" in data && data.count != undefined) this.count = data.count;
        }
    }

    get values(): MComment[] {
        return Message.getRepeatedWrapperField(this, MComment, 1);
    }
    set values(value: MComment[]) {
        Message.setRepeatedWrapperField(this, 1, value);
    }

    get count(): number {
        return Message.getField(this, 2) as number;
    }
    set count(value: number) {
        Message.setField(this, 2, value);
    }

    toObject(includeInstance: boolean = true) {
        const data = includeInstance ? new Comments() : {} as Comments;
        data.values = this.values.map(d => d.toObject(includeInstance));
        if (this.count != undefined) data.count = this.count;
        return data;
    }

    serialize(): Uint8Array
    serialize(w: BinaryWriter): undefined
    serialize(w?: BinaryWriter): Uint8Array | undefined {
        const writer = w || new BinaryWriter();
        try {
                if (this.values !== undefined) writer.writeRepeatedMessage(1, this.values, (i) => i.serialize(writer));
                if (this.count !== undefined) writer.writeInt32(2, this.count);
        
        } catch (e: any) {
            if (!w) console.error(e)
            throw e
        }
        if (!w) return writer.getResultBuffer();
    }

    serializeBinary(): Uint8Array {
        return this.serialize();
    }

    static serializeBinary(data?: IComments): Uint8Array {
        return (data instanceof Message ? (data as MComments) : new MComments(data)).serializeBinary()
    }


    static deserialize(bytes: Uint8Array | BinaryReader): MComments {
        const reader = bytes instanceof Uint8Array ? new BinaryReader(bytes) : bytes;
        const message = new MComments();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
            case 1:
                    reader.readMessage(message.values, () => Message.addToRepeatedWrapperField(message, 1, MComment.deserialize(reader), MComment));
                    break;
            case 2:
                    message.count = reader.readInt32();
                    break;
            
                default: reader.skipField();
            }
        }
        return message;
    }

    static override deserializeBinary(bytes: Uint8Array): MComments {
        return MComments.deserializeBinaryFromReader(new MComments(), new BinaryReader(bytes));
    }

    static override deserializeBinaryFromReader(msg: MComments, reader: BinaryReader) {
        return Object.assign(msg, MComments.deserialize(reader))
    };

}
                        




export default () => {}